import { invokeRPC } from './socket.js'

export function update(data) {
  return invokeRPC('powerpoint', 'publish', { spreadSheetData: data })
}

export function doesGoogleResourceExist(data) {
  return invokeRPC('powerpoint', 'doesGoogleResourceExist', data)
}

export function createSimpleTableauPowerPointExport(data) {
  return invokeRPC('powerpoint', 'createSimpleTableauPowerPointExport', data)
}

export function getTableauWorkbookFromSimplePowerPointExport(id) {
  return invokeRPC('powerpoint', 'getTableauWorkbookFromSimplePowerPointExport', { project_id: id })
}

export function getSimpleTableauPowerPointRecordForAdministration(id) {
  return invokeRPC('powerpoint', 'getSimpleTableauPowerPointRecordForAdministration', { project_id: id })
}

export function updateSimpleTableauPowerPoint(data) {
  return invokeRPC('powerpoint', 'updateSimpleTableauPowerPoint', data)
}

export function getTableauViewFromCPBuilder(id) {
  return invokeRPC('powerpoint', 'getTableauViewFromCPBuilder', { project_id: id })
}

export function getPowerPoints(id) {
  const data = {}
  if (id) {
    data.customer_id = id
  }
  return invokeRPC('powerpoint', 'getPowerPoints', data)
}

export function doesCustomerHavePowerPoints(id) {
  const data = {}
  if (id) {
    data.customer_id = id
  }
  return invokeRPC('powerpoint', 'doesCustomerHavePowerPoints', data)
}

export function reserveSimpleTableauPowerPointResourceIfAvailable(projectId) {
  return invokeRPC('powerpoint', 'reserveSimpleTableauPowerPointResourceIfAvailable', { project_id: projectId })
}

export function releaseSimpleTableauPowerPointResource(projectId) {
  return invokeRPC('powerpoint', 'releaseSimpleTableauPowerPointResource', { project_id: projectId })
}

export function getExportSimpleTableauPowerPointToken(data) {
  return invokeRPC('powerpoint', 'getExportSimpleTableauPowerPointToken', data)
}

export function getImagesFromPresentation(slideId) {
  return invokeRPC('powerpoint', 'getImagesFromPresentation', { slide_id: slideId })
}

export function getImagesData(projectId) {
  return invokeRPC('powerpoint', 'getImagesData', { project_id: projectId })
}